// Typelizer digest fd4d1d99575b8b63238acd794d16d0d8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename */
  show: (
    params: { signedBlobId: string | number; variationKey: string | number; filename: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename', params, options),
    method: 'get',
  }),
}
